import React, { Component } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./config/Store";
import Tyc from "./screens/login/Tyc";
import TycV2 from "./screens/login/TycV2";
import PrivacyPolicie from "./screens/login/PrivacyPolicie";
import App from "./App";
import "./App.css";


class Root extends Component {


  componentDidMount(){
    document.title = process.env.REACT_APP_APP_DISPLAY_NAME;
  }

  render() { 
    if (window.location.pathname == '/tyc' || window.location.pathname == '/privacy-policie' || window.location.pathname == '/privacy-policy'){ // Politica de privacidad, en algunos tenants estaba mal nombrada la ruta, como tyc
			//return (<Tyc></Tyc>);   Deprecado estaba mal nombrado 
      return (<PrivacyPolicie></PrivacyPolicie>);  
    }else if(window.location.pathname == '/tyc-v2'){ 
        return (<TycV2></TycV2>); 
		}else{
      return (
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      );
    }
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/Root.js